import { MEDIA_TABLET } from '@nike/ciclp-react-components/context/utils';
import {
  commonCMSpropertiesSelector,
  segmentTrackPayloadSelector,
  segmentViewPayloadSelector,
} from '../analyticsSelectors';
import {
  analyticsProperties,
  eventNames,
  iframeEventsNames,
  videoEventsNames,
} from '../constants';

export const getAnalyticsEvent = (eventName, state, eventData) => {
  const isMobile = window.innerWidth < MEDIA_TABLET;

  // Page load analytics
  if (eventName === eventNames.PAGE_VIEWED) {
    return segmentViewPayloadSelector(state, { isMobile });
  }
  if (
    [
      eventNames.CLICK,
      eventNames.NAVIGATION_CLICK,
      eventNames.BANNER_CLICK,
    ].includes(eventName)
  ) {
    const { actionId, placementId, clickContentLabel, videoData } = eventData;
    return segmentTrackPayloadSelector(state, {
      actionId,
      clickContentLabel,
      eventName,
      isMobile,
      placementId,
      videoData,
    });
  }
  if (
    [
      eventNames.NOTIFY_ME_CLICKED,
      eventNames.NOTIFY_ME_DISMISSED,
      eventNames.NOTIFY_ME_SUBMITTED,
    ].includes(eventName)
  ) {
    const { productId, clickActivity } = eventData;
    return { clickActivity, productId };
  }
  if ([eventNames.INTEREST_ADDED].includes(eventName)) {
    const { clickActivity } = eventData;
    return { clickActivity };
  }
  if (eventName === eventNames.IMPRESSION) {
    const { videoData } = eventData;
    const analyticsPropertiesValues = {
      ...(eventData[analyticsProperties.LANDMARK_X] !== undefined && {
        [analyticsProperties.LANDMARK_X]:
          eventData[analyticsProperties.LANDMARK_X],
      }),
      ...(eventData[analyticsProperties.LANDMARK_Y] !== undefined && {
        [analyticsProperties.LANDMARK_Y]:
          eventData[analyticsProperties.LANDMARK_Y],
      }),
      ...(eventData[analyticsProperties.TIMESTAMP] && {
        [analyticsProperties.TIMESTAMP]:
          eventData[analyticsProperties.TIMESTAMP],
      }),
      ...(eventData[analyticsProperties.COMPONENT_EXPIREMENT_ID] && {
        [analyticsProperties.COMPONENT_EXPIREMENT_ID]:
          eventData[analyticsProperties.COMPONENT_EXPIREMENT_ID],
      }),
    };
    return {
      ...analyticsPropertiesValues,
      ...segmentTrackPayloadSelector(state, {
        eventName,
        isMobile,
        placementId: eventData.placementId,
        videoData,
      }),
    };
  }
  if (Object.values(videoEventsNames).includes(eventName) && eventData) {
    const { placementId, videoData } = eventData;
    return {
      ...segmentTrackPayloadSelector(state, {
        isMobile,
        placementId,
        videoData,
      }),
    };
  }
  if (
    [
      eventNames.AUTOPLAY_NEXT_CLICK,
      eventNames.AUTOPLAY_PREVIOUS_CLICK,
      eventNames.AUTOPLAY_PLAY,
      eventNames.AUTOPLAY_PAUSE,
    ].includes(eventName)
  ) {
    const { clickActivity } = eventData;
    return { clickActivity };
  }
  if (eventName === eventNames.PRODUCT_ADDED) {
    const { productData, clickActivity } = eventData;

    return {
      ...segmentTrackPayloadSelector(state, {
        clickActivity,
        eventName,
        productData,
      }),
    };
  }
  if (Object.values(iframeEventsNames).includes(eventName) && eventData) {
    const { threadId } = commonCMSpropertiesSelector(state);

    return {
      ...eventData,
      threadId,
    };
  }
  return {};
};
